import Catalog from './Catalog'
import MapElement from './Map'
import ListComponents from './List'
import RouterParametersController from './RouterParametersController'
import PaginationComponents from './Pagination'
import Controls from './Controls'
import Elements from './UIElements'

export function install(Vue) {
  Vue.use(Catalog)
  Vue.use(Controls)
  Vue.use(MapElement)
  Vue.use(ListComponents)
  Vue.use(PaginationComponents)
  Vue.use(Elements)
  Vue.component('RouterParametersController', RouterParametersController)
}

export default { install }
